import { RootState } from 'handlers';

export const selectYourGoal = (state: RootState) => state.yourGoal;
